import { createStore } from 'redux'
import { persistReducer, persistStore } from 'redux-persist'
// encrypt local storage data || https://github.com/maxdeviant/redux-persist-transform-encrypt
import { encryptTransform } from 'redux-persist-transform-encrypt'
// defaults to localStorage for web and AsyncStorage for react-native
import storage from 'redux-persist/lib/storage'
import rootReducer from './reducers'

const storageKey = process.env.REACT_APP_SECRET_KEY

const persistConfig = {
	key: 'root',
	storage,
	whitelist: ['session', 'activePatient'],
	transforms: [
		encryptTransform({
			secretKey: storageKey || '',
			onError: (error: any) => {
				throw new Error(error)
			}
		})
	]
}

const persistedReducer = persistReducer(persistConfig, rootReducer)

const store = createStore(
	persistedReducer,
	window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
)
const persistor = persistStore(store)

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>

export default () => {
	return { store, persistor }
}
